import React from "react";
import { TableRow, TableCell, Box, Skeleton, Avatar } from "@mui/material";

const cellStyle = {
  padding: '10px 16px',
};

const BillingSkeleton = () => {
  return (
    <TableRow sx={{
      backgroundColor: '#fff',
      borderRadius: '10px',
    }}>
      <TableCell sx={{ 
        ...cellStyle, 
        border: 'none', 
        minWidth: '32px', 
        maxWidth: '32px',
        borderRadius: '10px 0 0 10px',
      }}>
        <Skeleton variant="circular" width={20} height={20} />
      </TableCell>

      <TableCell sx={{ ...cellStyle, border: 'none' }}>
        <Skeleton width={20} />
      </TableCell>

       

      <TableCell sx={{ ...cellStyle, border: 'none', textAlign: 'center' }}>
        <Skeleton width={80} />
      </TableCell>

      <TableCell sx={{ ...cellStyle, border: 'none', textAlign: 'center' }}>
        <Skeleton variant="rectangular" width={100} height={10} />
      </TableCell>  
       <TableCell sx={{ ...cellStyle, border: 'none', textAlign: 'center' }}>
        <Skeleton variant="rectangular" width={100} height={10} />
      </TableCell>  
       <TableCell sx={{ ...cellStyle, border: 'none', textAlign: 'center' }}>
        <Skeleton variant="rectangular" width={100} height={10} />
      </TableCell>  
        

      <TableCell sx={{ 
        ...cellStyle, 
        border: 'none', 
        textAlign: 'center',
        borderRadius: '0px 10px 10px 0px' 
      }}>
        <Skeleton width={80} />
      </TableCell>
    </TableRow>
  );
};

export default BillingSkeleton;
